<div>
    <img style="width: 75%;height: 75%;margin-bottom: 5%;" id="avatar" [src]="data.name">
</div>